
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'Alert',
  props: ['item', 'index'],
})
export default class Alert extends Vue {}
